import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .Container__header {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 20px;
    }
`;

export const DetailsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;

    .DetailItem {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 5px 15px;
        border-radius: 8px;
        min-width: 105px;
        
        &.planejada {
            
            strong, .Value {
                color: var(--text-color); /* roxo escuro */
            }
        }

        &.executada {
            background-color: rgba(93, 165, 125, 0.1);
            
            strong, .Value {
                color: var(--primary-color);
            }
        }

        strong {
            font-size: 13px;
            font-weight: 500;
        }

        .Value {
            font-size: 16px;
            font-weight: 700;
        }
    }
`;

export const ProgressBarContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    width: 100%;
    padding: 10px 0;

    .ProgressBarContainer__title {
        font-weight: 600;
        font-size: 13px;
        color: var(--text-color-light);
    }

    .ProgressBarContainer__bar {
        flex: 1;
        height: 8px;
        background-color: #f5f5f5;
        border-radius: 15px;
        position: relative;
        overflow: hidden;

        div.bar-fill {
            height: 100%;
            background-color: var(--green-precision);
            border-radius: 15px;
            z-index: 1;
            position: relative;

            &[data-error='true'] {
                background-color: red;
            }

            &[data-warning='true'] {
                background-color: #FFCC00;
            }

            &[data-small='true'] {
                background-color: #3e8efb;
            }

            &[data-precise='true'] {
                background-color: #7ebd61;
            }
        }
    }

    .ProgressBarContainer__value {
        font-weight: 700;
        font-size: 13px;
        width: 45px;
        text-align: right;
        white-space: nowrap;
    }
`;